import BaseForm from '@kakadu-dev/base-frontend-helpers/forms/BaseForm';
import { Customer } from "../../../models/Customers";
import { DispatchSelector, StateSelector } from "../../../modules/selectors";
/**
 * Customer push notification form
 */

export class CustomerPushNotificationForm extends BaseForm {
  constructor(...args) {
    super(...args);
    this.modelClass = Customer;
    this.fields = [{
      label: 'Тип',
      name: 'type',
      type: BaseForm.TYPES.DROPDOWN,
      required: true,
      props: {
        common: {
          data: BaseForm.getDropdownOptions(Customer.pushTargetTitles)
        }
      }
    }, {
      label: 'Цель',
      name: 'target',
      type: BaseForm.TYPES.DROPDOWN,
      required: true,
      props: {
        common: {
          data: BaseForm.getDropdownOptions(Customer.pushTopicsTitles)
        }
      }
    }, {
      label: 'Заголовок',
      name: 'message.title'
    }, {
      label: 'Сообщение',
      name: 'message.description',
      required: true
    }, {
      label: 'Тип пользователя',
      name: 'message.customerType',
      isHidden: true,
      type: BaseForm.TYPES.DROPDOWN,
      props: {
        common: {
          data: BaseForm.getDropdownOptions(Customer.pushNotificationTitles)
        }
      }
    }];
    this.dispatchCreateForm = DispatchSelector.customers.sendPush;
    this.responseCreateState = StateSelector.customers.sendPush;
  }

}